import theme from "@/theme";

export const styles = {
  modal: {
    width: "506px",
    minHeight: "461px",
    borderRadius: "24px",
    p: "22px",
    background: "#FFFFFF",
    boxShadow: "0px 0px 4px 0px #0000001A",
    overflow: "hidden",
  },
  header: {
    width: "462px",
    height: "42px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: "38px",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  headerText: {
    height: "19px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    color: "#2A2D31",
    letterSpacing: "2%",
  },
  body: {
    width: "462px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  label: {
    height: "19px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    color: "#2A2D31",
    letterSpacing: "2%",
  },
  zapGrid: {
    padding: "0 16px",
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    alignItems: "flex-start",
    width: "100%",
  },
  zapItem: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 16px",
    height: "42px",
    borderRadius: "32px",
    border: "1px solid #E4E7E9",
    background: "#F8F9F9",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  otherOption: {
    color: "#C6CACE",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  usdText: {
    fontSize: "12px",
    color: "#6B6E75",
  },
  commentInput: {
    height: "48px",
    padding: "0 16px",
    mb: "12px",
    "& .MuiOutlinedInput-root": {
      paddingLeft: "12px",
      paddingRight: "12px",
      borderRadius: "15px",
      height: "48px",
      padding: "0 12px",
      "& input": {
        height: "100%",
        padding: 0,
        lineHeight: "48px",
        boxSizing: "border-box",
        fontSize: "16px",
        "&::placeholder": {
          padding: 0,
          minHeight: "20px",
          fontFamily: "Inter",
          fontWeight: 500,
          lineHeight: "150%",
          color: "#D6D6D6",
          opacity: 1,
        },
      },
    },
  },

  sendButton: {
    height: "52px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "18px",
    textAlign: "center",
    borderRadius: "30px",
    borderColor: theme.palette.custom.mainBlue,
    color: theme.palette.custom.mainBlue,
    gap: "8px",
  },

  lightningIconDisabled: {
    "& .lightning-icon path": {
      fill: "none",
    },
  },
};
